import styled from "styled-components";
import media from "utils/styleUtils";

export const ButtonGroup = styled.div`
  position: absolute;
  bottom: 8vh;
  ${media.ipad`
      bottom: 7vh;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/common/WizardButtonGroup/WizardButtonGroup.style.tsx